import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'app'

const getFilesState = (state: RootState) => state.common.files

export const getLawsuitAttachmentsState = createSelector(
  getFilesState,
  state => state.lawsuitAttachments
)
